// src/components/common/EmptyState.jsx
//
// Shared "no data" state -- the one canonical empty-state component (see
// src/components/ui/ for the rest of the shared design system, which
// reuses this component rather than duplicating it). Renders via the
// shared ui.css classes (src/components/ui/ui.css) so every consumer --
// old (management pages, Review Forms) and new (DataTable, etc.) -- gets
// the same compact, branded icon/heading/message/action shape.
import React from "react";
import { FaInbox } from "react-icons/fa";
import "../ui/ui.css";

export default function EmptyState({
  icon: Icon = FaInbox,
  title = "Nothing here yet",
  message,
  action,
}) {
  return (
    <div className="ui-state">
      <div className="ui-state-icon ui-state-icon-neutral">
        <Icon size={20} />
      </div>
      <h5>{title}</h5>
      {message && <p>{message}</p>}
      {action}
    </div>
  );
}
